import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "editBrandCategory" */ "./UpdateProductWalkthrough"),{
		fallback: <div>Loading...</div>
	})
};
